import React from 'react';
import CalendarWeeklyView from '../../../components/views/CalendarWeeklyView';
import CalendarColWeeklyView from '../../../components/views/CalendarColWeeklyView';
import SwitchStyle1 from '../../../components/useful/SwitchButton';



export default class Calendar extends React.Component {

    state = {
        col: false,

    }

    componentDidMount() {
    }

    // nextStage = (cb) => {
    //     // this.setState({ isLoading: true, errors: {} })
    //     if (this.form) {daysData
    //         let data = this.form.getForm()
    //         if (data) {
    //             this.props.setData(data, () => {
    //                 // this.props.postUserInfo((result, err) => {
    //                 // if (err) { this.setState({ errors: err }) }
    //                 // this.setState({ isLoading: false })
    //                 this.props.chooseNextPage()

    //                 // })
    //             })
    //         }
    //     }
    // }





    render() {
        let col = this.state.col



        return (
            <>
                {/* <div className="px-2" style={{position:"relative",}}>
                    <SwitchStyle1 isOn={false} onChange={(ison)=>this.setState({col:ison})} />
                </div> */}


                {!col && <CalendarWeeklyView submitForm={this.props.submitForm} data={this.props.data} daysData={this.props.daysData} currentCalendar={this.props.currentCalendar} view={this.props.view} functionsHandler={this.props.functionsHandler} headers={this.props.headers} actions={this.props.actions} page={this.props.page} permissions={this.props.permissions}  />}
                {col && <CalendarColWeeklyView submitForm={this.props.submitForm} data={this.props.data} daysData={this.props.daysData} currentCalendar={this.props.currentCalendar} view={this.props.view} functionsHandler={this.props.functionsHandler} headers={this.props.headers} actions={this.props.actions} page={this.props.page} permissions={this.props.permissions} />}
            </>

        )
    }
}